// VFX: Text Scramble Decode
// Category: char-reveals · Tags: text, scramble, decode, glitch, tech
// Texto embaralhado que se revela caractere por caractere. Estilo hacker/tech.
import { AbsoluteFill, useCurrentFrame, random } from "remotion";
import React from "react";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%&";

export interface TextScrambleDecodeProps {
  text?: string;
  fontSize?: number;
  color?: string;
  accentColor?: string;
  revealDelay?: number;
}

export default function TextScrambleDecode({
  text = "SYSTEM ACTIVE",
  fontSize = 56,
  color = "#06b6d4",
  accentColor = "#f8fafc",
  revealDelay = 3,
}: TextScrambleDecodeProps) {
  const frame = useCurrentFrame();
  const chars = text.split("");
  const revealed = Math.floor(frame / revealDelay);
  return (
    <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", background: "#050508" }}>
      <div style={{ display: "flex", gap: "0.05em" }}>
        {chars.map((char, i) => {
          if (char === " ") return <span key={i} style={{ width: "0.3em" }} />;
          const isRevealed = i < revealed;
          const scrambleChar = isRevealed
            ? char
            : CHARS[Math.floor(random(`scramble-${i}-${frame}`) * CHARS.length)];
          return (
            <span key={i} style={{
              fontSize,
              fontWeight: 700,
              fontFamily: "'Courier New', monospace",
              color: isRevealed ? accentColor : color,
              opacity: isRevealed ? 1 : 0.5 + Math.sin(frame * 0.3 + i) * 0.3,
              letterSpacing: "2px",
            }}>{scrambleChar}</span>
          );
        })}
      </div>
      <div style={{ position: "absolute", bottom: "30%", width: "60%", height: 1, background: `linear-gradient(90deg, transparent, ${color}, transparent)`, opacity: 0.4 }} />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
